export default function GrainOverlay() {
  return <div className="grain-overlay" aria-hidden />;
}
